<template>
  <section class="inner-page">
    <h4>Informação Pessoal</h4>
    <input placeholder="Nome" v-model="name" name="name">
    <input placeholder="Email" v-model="email" name="email" type="email">
    <elvas-button :button="{title: 'guardar'}" @click.native="save()"/>
  </section>
</template>
<script>
import ElvasButton from '../../../components/elvas-button.vue'
export default {
  data () {
    return {
      name: this.$store.state.user.name,
      email: this.$store.state.user.email
    }
  },
  methods: {
    async save () {
      let data = await this.api.put('user', {name: this.name, email: this.email})
      
      localStorage.setItem('user', JSON.stringify(data.data))
      this.$store.state.user = data.data
    }
  }
}
</script>

<style lang="scss">
@media screen and (max-width: 940px){
  .inner-page {
    margin-bottom: 32px;
  }
}

@media screen and (max-width: 500px){
  .inner-page {
    margin-bottom: 32px;
  }
}

</style>
